import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// pattern components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx';

//own components
import './ProductSection.css';

class ProductSection extends React.Component {
  componentDidMount() {
    //   var euSign = new EndUser(
    //     "sign-widget-parent", /* Ідентифікатор батківського елементу */
    //     "sign-widget", /* Ідентифікатор елементу iframe */
    //     "https://eu.iit.com.ua/sign-widget/v20190408/",
    //     /* URI для завантаження iframe */
    //     EndUser.FormType.SignFile /* Тип форми iframe */
    //     );
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer className="productPage">
          <GridItem xs={12} sm={12}>
            {/* <h1 className="text-center"><span className="block text-danger ">УВАГА! </span> </h1> */}
            {/* <h1 className="text-center mb-5"><span className="block text-danger ">4 липня, з 10 до 13 години тимчасово не буде працювати Інтегрована система електронної ідентифікації. Будуть проводитися регламентні роботи із системою.</span> </h1> */}
            {/* <h1 className="text-center"><span className="block text-danger ">Сервіс працює в режимі ознайомлення</span> </h1> */}
            {/* <h1 className="text-center"><span className="block text-danger ">Сервіс тимчасово не працює</span> </h1> */}
            {/* <GridItem xs={12} sm={12} md={12} className="ml-5 ml-md-3">
              <h5 className="text-danger bold">
                Постанова Кабінету Міністрів України від 22.07.2020 №641
                передбачає завершення програми щодо виплат з 01.09.2020 року
                допомоги на дітей фізичним особам – підприємцям.
              </h5>
            </GridItem> */}
            <h1 className={'text-center block'}>Опис системи</h1>
            <div className="description mt-3">
              Відповідно до Постанови Кабінету Міністрів України від 22 квітня
              2020 року №329 надається допомога на дітей фізичним
              особам-підприємцям, які обрали спрощену систему оподаткування, та
              належать до першої і другої групи платників єдиного податку.
            </div>
            <div className="description">
              Допомога призначається на період карантину, встановленого
              постановою Кабінету Міністрів України від 11 березня 2020 р. № 211
              “Про запобігання поширенню на території України гострої
              респіраторної хвороби COVID-19, спричиненої коронавірусом
              SARS-CoV-2” (Офіційний вісник України, 2020 р., № 23, ст. 896) —
              із змінами, внесеними постановою Кабінету Міністрів України від 2
              квітня 2020 р. № 255, та на один місяць після дати його відміни
              одному з батьків на кожну дитину до досягнення нею 10 річного віку
              (включно) у розмірі прожиткового мінімуму, встановленого для дітей
              відповідних вікових груп станом на 1 січня 2020 року, і
              виплачується щомісячно за повний місяць.
            </div>
            <div className="description">
              Станом на 1 січня 2020 року розмір прожиткового мінімуму на дітей
              віком до 6 років становить 1779,00 грн., від 6 до 10 років
              становить 2218,00 грн.
            </div>
            <div className="description">
              Право на отримання допомоги на дітей фізичним особам-підприємцям,
              які обрали спрощену систему оподаткування, та належать до першої і
              другої групи платників єдиного податку мають громадяни України,
              іноземці та особи без громадянства, які є батьками, опікунами
              дитини і на законних підставах проживають на території України та
              сплатили єдиний податок.
            </div>
            <div className="description mb-3">
              Право на допомогу на дітей фізичним особам-підприємцям, які обрали
              спрощену систему оподаткування, та належать до першої і другої
              групи платників єдиного податку не надається батькам, які вже
              отримують відшкодування вартості послуги „муніципальна няня” на
              зазначену дитину.
            </div>

            <div>
              <ul className="m-0 p-0">
                <h3>Перелік потрібних документів:</h3>
              </ul>
              <li>
                {' '}
                заява, яка складається з персональних даних заявника, даних про
                дітей та даних для перерахування коштів.
              </li>
              <li> сканована копія свідоцтва про народження дитини (дітей);</li>
              <li>
                {' '}
                сканована копія довідки з ПФУ про сплату ЄСВ (форма ОК-7);
              </li>
              <li>
                сканована копія документу, що посвідчує проживання на території
                України (для іноземців);
              </li>
              <li>
                {' '}
                сканована копія рішення районної, районної у мм. Києві та
                Севастополі держадміністрацій, виконавчого органу міської,
                районної у місті (у разі створення) ради, сільської, селищної
                ради об’єднаної територіальної громади або суду про встановлення
                опіки (у разі здійснення опіки над дитиною).
              </li>
            </div>
          </GridItem>
        </GridContainer>

        {/* <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Free Chat"
                description="Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature will be enough."
                icon={Chat}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Verified Users"
                description="Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature will be enough."
                icon={VerifiedUser}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Fingerprint"
                description="Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature will be enough."
                icon={Fingerprint}
                iconColor="danger"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div> */}
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);
